import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { Auth0Interceptor } from "./auth0.interceptor";
import { AuthenticationInterceptor } from "./authentication.interceptor";
import { AuthorizationInterceptor } from "./authorization.interceptor";
import { InternetExplorerInterceptor } from "./internet-explorer.interceptor";
import { LoaderInterceptor } from "./loader.interceptor";
import { LoggingInterceptor } from "./logging.interceptor";

export const InterceptorList = [
  { provide: HTTP_INTERCEPTORS, useClass: AuthenticationInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: AuthorizationInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: InternetExplorerInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: LoggingInterceptor, multi: true },
  { provide: HTTP_INTERCEPTORS, useClass: Auth0Interceptor, multi: true},
];
